import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-menu" }

import WhatsIncluded from "@/components/pages/index/WhatsIncluded.vue";
import MoreDiscounts from "@/components/pages/index/MoreDiscounts.vue";
import BestPlan from "@/components/pages/index/BestPlan.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeMenuDown',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WhatsIncluded),
    _createVNode(MoreDiscounts),
    _createVNode(BestPlan)
  ]))
}
}

})